import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import {
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
  INSIDE_THE_HEADER,
} from "constants/ActionTypes";
import SearchBox from "components/SearchBox";
import AppNotification from "../AppNotification";
import { switchLanguage, toggleCollapsedNav } from "redux/actions/Setting";
import LanguageSwitcher from "components/LanguageSwitcher/index";
import Menu from "components/TopNav/Menu";
import UserInfoPopup from "components/UserInfo/UserInfoPopup";
// import { logoutAdminRequest } from "redux/actions/Auth";
import { store } from "redux/store";
import LogoFull from "assets/images/logo-full.svg";
import { logoutRequestAction } from "./../../redux/actions/AuthActions";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { useSelector } from "react-redux";
import { whiteColor } from "assets/colors";
import { LOGOUT_STARTED, UPDATE_TIME_ZONE_STARTED } from "redux/ActionTypes";
import {
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Autocomplete from "components/Autocomplete";
import {
  getTimeZonesRequestAction,
  updateTimeZoneRequestAction,
} from "redux/actions/GeneralActions";
import Button from "components/Button";
class Header extends React.Component {
  componentDidMount = () => {
    this.props.getTimeZonesRequestAction();
  };
  onAppNotificationSelect = () => {
    this.setState({
      appNotification: !this.state.appNotification,
    });
  };
  onMailNotificationSelect = () => {
    this.setState({
      mailNotification: !this.state.mailNotification,
    });
  };
  onLangSwitcherSelect = (event) => {
    this.setState({
      langSwitcher: !this.state.langSwitcher,
      anchorEl: event.currentTarget,
    });
  };
  onDateSwitcherSelect = (event) => {
    this.setState({
      dateSwitcher: !this.state.dateSwitcher,
      anchorEl: event.currentTarget,
    });
  };
  onSearchBoxSelect = () => {
    this.setState({
      searchBox: !this.state.searchBox,
    });
  };
  onAppsSelect = () => {
    this.setState({
      apps: !this.state.apps,
    });
  };
  onUserInfoSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo,
    });
  };
  handleRequestClose = () => {
    this.setState({
      langSwitcher: false,
      dateSwitcher: false,
      userInfo: false,
      mailNotification: false,
      appNotification: false,
      searchBox: false,
      apps: false,
    });
  };
  onToggleCollapsedNav = (e) => {
    const val = !this.props.navCollapsed;
    this.props.toggleCollapsedNav(val);
  };

  constructor() {
    super();
    this.state = {
      anchorEl: undefined,
      searchBox: false,
      searchText: "",
      mailNotification: false,
      userInfo: false,
      langSwitcher: false,
      dateSwitcher: false,
      appNotification: false,
      loading: true,
      timeZoneId: 0,
      openUpdateTimeZone: false,
    };
  }

  updateSearchText(evt) {
    this.setState({
      searchText: evt.target.value,
    });
  }

  Apps = () => {
    return (
      <ul className="jr-list jr-list-half">
        <li className="jr-list-item">
          <Link
            className="jr-list-link"
            to="/app/transactions/all-transactions"
          >
            <i className="zmdi zmdi-swap zmdi-hc-fw" />
            <span className="jr-list-text">Transactions</span>
          </Link>
        </li>

        <li className="jr-list-item">
          <Link className="jr-list-link" to="/app/users/pending-items">
            <i className="zmdi zmdi-spinner zmdi-hc-fw" />
            <span className="jr-list-text">Pending</span>
          </Link>
        </li>

        <li className="jr-list-item">
          <Link className="jr-list-link" to="/app/gateways/all-gateways">
            <i className="zmdi zmdi-center-focus-strong zmdi-hc-fw" />
            <span className="jr-list-text">Gateways</span>
          </Link>
        </li>

        <li className="jr-list-item">
          <Link className="jr-list-link" to="/app/system/system-log">
            <i className="zmdi zmdi-settings-square zmdi-hc-fw" />
            <span className="jr-list-text">SystemLog</span>
          </Link>
        </li>

        <li className="jr-list-item">
          <Link className="jr-list-link" to="/app/contact">
            <i className="zmdi zmdi-account-box zmdi-hc-fw" />
            <span className="jr-list-text">
              {/* <IntlMessages id="sidebar.appModule.contact" /> */}
            </span>
          </Link>
        </li>

        <li className="jr-list-item">
          <Link className="jr-list-link" to="/">
            <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw" />
            <span className="jr-list-text">Add New</span>
          </Link>
        </li>
      </ul>
    );
  };

  render() {
    const {
      drawerType,
      locale,
      navigationStyle,
      horizontalNavPosition,
      authReducer,
      auth,
      general,
    } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "d-block d-xl-none"
      : drawerType.includes(COLLAPSED_DRAWER)
      ? "d-block"
      : "d-none";
    const selectedTimeZone =
      general.timeZones.length > 0
        ? general.timeZones.find((t) => t.id === auth.user.timezone_id)
        : null;
    const loading = auth.rType === UPDATE_TIME_ZONE_STARTED;

    return (
      <AppBar
        className={`app-main-header ${
          navigationStyle === HORIZONTAL_NAVIGATION &&
          horizontalNavPosition === BELOW_THE_HEADER
            ? "app-main-header-top"
            : ""
        }`}
      >
        <Toolbar className="app-toolbar" disableGutters={false}>
          {navigationStyle === HORIZONTAL_NAVIGATION ? (
            <div
              className="d-block d-md-none pointer mr-3"
              onClick={this.onToggleCollapsedNav}
            >
              <span className="jr-menu-icon">
                <span className="menu-icon" />
              </span>
            </div>
          ) : (
            <IconButton
              className={`jr-menu-icon mr-3 ${drawerStyle}`}
              aria-label="Menu"
              onClick={this.onToggleCollapsedNav}
            >
              <span className="menu-icon" />
            </IconButton>
          )}

          <Link className="app-logo mr-2 d-none d-sm-block" to="/app/dashboard">
            <LogoFull width={100} color={whiteColor} />
          </Link>

          {auth.user.permissions &&
            auth.user.permissions.some(
              (permission) => permission === "Search Users"
            ) && (
              <SearchBox
                styleName="d-block"
                placeholder=""
                value={this.state.searchText}
              />
            )}

          {navigationStyle === HORIZONTAL_NAVIGATION &&
            horizontalNavPosition === INSIDE_THE_HEADER && <Menu />}

          <ul className="header-notifications list-inline ml-auto">
            <li className="list-inline-item">
              <Chip
                icon={
                  <Avatar
                    src={`https://flagcdn.com/${selectedTimeZone?.code.toLowerCase()}.svg`}
                    sx={{ width: 20, height: 20 }}
                  />
                }
                label={selectedTimeZone?.timezone}
                onClick={() => this.setState({ openUpdateTimeZone: true })}
              />
            </li>
            {/* <li className="list-inline-item">
              <Dropdown
                className="quick-menu app-notification"
                isOpen={this.state.apps}
                toggle={this.onAppsSelect.bind(this)}
              >
                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown"
                >
                  <span className="app-notification-menu">
                    <i className="zmdi zmdi-apps zmdi-hc-fw zmdi-hc-lg" />
                    <span>
                      <IntlMessages id="quick.access" />
                    </span>
                  </span>
                </DropdownToggle>

                <DropdownMenu>{this.Apps()}</DropdownMenu>
              </Dropdown>
            </li> */}
            {/* <li className="d-inline-block d-lg-none list-inline-item">
              <Dropdown
                className="quick-menu nav-searchbox"
                isOpen={this.state.searchBox}
                toggle={this.onSearchBoxSelect.bind(this)}
              >
                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown"
                >
                  <IconButton className="icon-btn">
                    <i className="zmdi zmdi-search zmdi-hc-fw" />
                  </IconButton>
                </DropdownToggle>

                <DropdownMenu className="p-0">
                  <SearchBox
                    styleName="search-dropdown"
                    onChange={this.updateSearchText.bind(this)}
                    value={this.state.searchText}
                  />
                </DropdownMenu>
              </Dropdown>
            </li> */}

            {/* <li className="list-inline-item">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.langSwitcher}
                toggle={this.onLangSwitcherSelect.bind(this)}
              >
                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown"
                >
                  <IconButton className="icon-btn">
                    <i className={`flag flag-24 flag-${locale.icon}`} />
                  </IconButton>
                </DropdownToggle>

                <DropdownMenu right className="w-50">
                  <LanguageSwitcher
                    switchLanguage={this.props.switchLanguage}
                    handleRequestClose={this.handleRequestClose}
                  />
                </DropdownMenu>
              </Dropdown>
            </li> */}

            <IconButton
              onClick={() =>
                this.props.logoutRequestAction({
                  userID: this.props.auth.user.id,
                })
              }
              disabled={this.props.auth.rType === LOGOUT_STARTED}
            >
              {this.props.auth.rType === LOGOUT_STARTED ? (
                <CircularProgress color="white" size={18} />
              ) : (
                <PowerSettingsNewIcon sx={{ color: whiteColor }} />
              )}
            </IconButton>
            {navigationStyle === HORIZONTAL_NAVIGATION && (
              <li className="list-inline-item user-nav">
                <Dropdown
                  className="quick-menu"
                  isOpen={this.state.userInfo}
                  toggle={this.onUserInfoSelect.bind(this)}
                >
                  <DropdownToggle
                    className="d-inline-block"
                    tag="span"
                    data-toggle="dropdown"
                  >
                    <IconButton className="icon-btn size-30">
                      <Avatar
                        alt="..."
                        src={"https://via.placeholder.com/150x150"}
                        className="size-30"
                      />
                    </IconButton>
                  </DropdownToggle>

                  <DropdownMenu right>
                    <UserInfoPopup />
                  </DropdownMenu>
                </Dropdown>
              </li>
            )}
          </ul>

          <div className="ellipse-shape"></div>
        </Toolbar>
        <Dialog open={this.state.openUpdateTimeZone}>
          <DialogTitle>Update Time Zone</DialogTitle>
          <DialogContent dividers>
            <Autocomplete
              label={"Timezone"}
              options={general.timeZones}
              getOptionLabel={(option) => option.timezone}
              value={
                general.timeZones.length > 0
                  ? general.timeZones.find(
                      (t) => t.id === auth.user.timezone_id
                    )
                  : null
              }
              onChange={(event, value) => {
                this.setState({ timeZoneId: value.id });
              }}
              fullidth
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="text"
              text={"Cancel"}
              onClick={() => this.setState({ openUpdateTimeZone: false })}
            />
            <Button
              text={"Submit"}
              onClick={() =>
                this.props.updateTimeZoneRequestAction({
                  timeZoneId: this.state.timeZoneId,
                  onSuccess: () => this.setState({ openUpdateTimeZone: false }),
                })
              }
              loading={loading}
            />
          </DialogActions>
        </Dialog>
      </AppBar>
    );
  }
}

const mapStateToProps = ({ settings, auth, general }) => {
  const { drawerType, locale, navigationStyle, horizontalNavPosition } =
    settings;

  return {
    auth,
    drawerType,
    locale,
    navigationStyle,
    horizontalNavPosition,
    general,
  };
};

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  switchLanguage,
  logoutRequestAction,
  getTimeZonesRequestAction,
  updateTimeZoneRequestAction,
})(Header);
